import React from 'react'
import { useTheme } from '@mui/material/styles'

import AppBar from '@mui/material/AppBar'
import Toolbar from '@mui/material/Toolbar'

import AppIcon from './AppIcon'
import { paddingHorizontal } from '../utils/AppConstants'

export default function HeaderCommon () {
  var theme = useTheme()

  return (
    <AppBar
      sx={{
        bgcolor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.border.main}`
      }}
      elevation={0}
    >
      <Toolbar
        style={{
          height: '60px',
          paddingLeft: paddingHorizontal,
          paddingRight: paddingHorizontal
        }}
      >
        <AppIcon style={{ width: 80 }} />
      </Toolbar>
    </AppBar>
  )
}
